export function SessionStatusScreen() {
  return (
    <main className="login-screen">
      <section className="login-card login-card--compact">
        <p className="login-card__eyebrow">Checking session</p>
        <h1 className="login-card__title">Work Track System</h1>
        <p className="login-card__copy">Restoring your session...</p>
      </section>
    </main>
  );
}
